<div
  class="border-round-md mb-6 p-2 shadow-3"
  style="background-color: #15448c">
  <a routerLink="/user/settings">
    <div
      class="flex align-items-center pb-2 border-bottom-1"
      style="border-color: #323468">
      <crm-user-avatar
        [user]="$any(currentUser)"
        shape="circle"
        size="large"></crm-user-avatar>
      <div
        class="ml-2"
        *ngIf="!minimized">
        <p class="text-0 font-medium">{{ currentUser?.profile?.name }}</p>
        <p class="text-300 text-sm mt-1">{{ currentUser?.job }}</p>
      </div>
    </div>
  </a>
  <div
    *ngIf="!minimized; else actionIconsTemplate"
    class="flex align-items-center justify-content-between gap-2 px-3 pt-3 pb-2">
    <div>
      <div
        *ngIf="globalService.globalInfo?.config?.multiTenancyEnabled"
        class="flex-grow-1 flex align-items-center gap-3 text-gray-200 cursor-pointer hover:text-white"
        (click)="openTenantDialog()">
        <i
          class="pi pi-reply"
          style="font-size: 1.4rem"></i>
        <p>Перейти</p>
      </div>
    </div>
    <div class="flex-none">
      <i
        class="pi pi-sign-out text-gray-200 cursor-pointer hover:text-white"
        pTooltip="Выход"
        [showDelay]="300"
        tooltipPosition="top"
        style="font-size: 1.4rem"
        (click)="logout()"></i>
    </div>
  </div>
  <ng-template #actionIconsTemplate>
    <div class="flex flex-column justify-content-center w-full">
      <div
        *ngIf="globalService.globalInfo?.config?.multiTenancyEnabled"
        class="text-center pt-3">
        <i
          class="pi pi-reply text-gray-300 cursor-pointer hover:text-white"
          pTooltip="Перейти на другой аккаунт"
          [showDelay]="300"
          tooltipPosition="right"
          style="font-size: 1.5rem"
          (click)="openTenantDialog()"></i>
      </div>
      <div class="text-center pt-4 pb-1">
        <i
          class="pi pi-sign-out text-gray-300 cursor-pointer hover:text-white"
          pTooltip="Выход"
          [showDelay]="300"
          tooltipPosition="right"
          style="font-size: 1.5rem"
          (click)="logout()"></i>
      </div>
    </div>
  </ng-template>
</div>

<p-panelMenu [model]="items"></p-panelMenu>

<p-dialog
  header="Перейти на другой аккаунт"
  styleClass="xl:w-4 md:w-7 w-11"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="isShowTenantDialog">
  <ng-container *ngIf="tenants?.length; else notTenantsTemplate">
    <div class="flex align-items-center flex-wrap gap-3">
      <div
        *ngFor="let tenant of tenants"
        class="border-1 border-gray-300 cursor-pointer hover:bg-blue-50 border-round-xl p-4"
        (click)="redirectToTenant(tenant)">
        <p class="text-lg font-bold text-center">{{ tenant.name }}</p>
      </div>
    </div>
  </ng-container>

  <div class="mt-5">
    <div class="grid justify-content-center align-items-center flex-wrap">
      <button
        pButton
        icon="pi pi-plus"
        label="Добавить аккаунт"
        class="p-button-text"
        routerLink="/register"></button>
    </div>
  </div>

  <ng-template #notTenantsTemplate>
    <p class="text-xl font-bold my-3 text-center">Нет других аккаунтов</p>
  </ng-template>
</p-dialog>
